import * as React from 'react'
import styled from 'styled-components'
import I18n from '../../../../core/i18n'
import { IJsonResponse } from '../../../../core/JsonApiSerializer'
import { agentService, utilService } from '../../../../core/services'
import { CheckBox, InputRadio, InputText } from '../../../atoms'
import SidebarLayout from '../../_layouts/sidebarLayout'
import AgentLayoutEdit from '../_layouts/edit'
import * as interfaces from '../../../../static/interfaces'

declare var window: interfaces.IWindow

interface IProps {
  agent_rank: IJsonResponse
  user: any
}

const FIELDS = {
  id: 'id',
  name: 'name',
  rank_kind: 'rank_kind',
  position: 'position',
  enabled: 'enabled',
  is_base: 'is_base',
}

const RANK_KIND_OPTIONS = [
  { id: 'normal', value: 'normal', label: I18n.t('agent_rank.kind_normal') },
  { id: 'special', value: 'special', label: I18n.t('agent_rank.kind_special') },
]

const title = I18n.t('admin.edit', {
  model: I18n.t('agent_rank', { scope: 'activerecord.models' }),
})

const AgentRanksEdit: React.FC<IProps> = props => {
  const { data } = agentService.getDataFromJson(props.agent_rank)
  const { data: userData } = utilService.getDataFromJson(props.user)
  const [isSpecial, setIsSpecial] = React.useState(data.rank_kind === 'special')
  const [isBase, setIsBase] = React.useState<boolean>(data.is_base)
  const handleSubmit = React.useCallback(async (initialValues, values) => {
    try {
      const { flush } = await agentService.updateAgentRank(values)
      window.flashMessages.addMessage({ text: flush.message, type: flush.type })
      location.href = '/agent/agent_ranks'
    } catch (error) {
      // バリデーションエラー等はhttpClientのinterceptorがflashを表示するため、入力内容を残して留まる
    }
  }, [])

  return (
    <SidebarLayout user={userData} showSidebar={true}>
      <AgentLayoutEdit
        model="agent_ranks"
        title={title}
        fields={FIELDS}
        hideAgentNav={true}
        indexLink="/agent/agent_ranks"
        formItems={
          <FormItems>
            <InputText
              readonly={true}
              name="id"
              defaultValue={data.id}
              label={I18n.t('generic.id')}
            />
            <InputText
              required={true}
              name="name"
              defaultValue={data.name}
              label={I18n.t('generic.name')}
            />
            <InputRadio
              required={true}
              name="rank_kind"
              defaultValue={data.rank_kind}
              options={RANK_KIND_OPTIONS}
              label={I18n.t('agent_rank.kind')}
              onChangeHandler={event => setIsSpecial(event.target.value === 'special')}
            />
            <InputText
              required={true}
              type="number"
              name="position"
              defaultValue={data.position}
              label={I18n.t('generic.position')}
            />
            <CheckBox
              name="enabled"
              defaultChecked={data.enabled}
              label={I18n.t('agent_rank.enabled')}
            />
            {/* 特殊ランクはBaseにできないため選択中は隠し、FormがDOMから読む値も false にする */}
            {/* is_baseはagent単位で1つのみ設定可能 */}
            <div hidden={isSpecial}>
              <CheckBox
                name="is_base"
                checked={!isSpecial && isBase}
                onChangeHandler={event => setIsBase(event.target.checked)}
                label={I18n.t('agent_rank.base')}
              />
            </div>
          </FormItems>
        }
        handleSubmit={handleSubmit}
      />
    </SidebarLayout>
  )
}

// 共通レイアウトのCSSはInputRadioの前後に余白を持たないため、ここで他フォームと同じ間隔を補う
const FormItems = styled.div`
  > * + * {
    margin-top: 24px;
  }
`

export default AgentRanksEdit
